export default __webpack_public_path__ + "static/media/vive argentina.f1b506dc.mp4";